import React, { useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import useFetchXCSI from "../../../hooks/useFetchXCSI";
import useExportXCSI from "../../../hooks/useExportXCSI";
import useFirestore from "../../../config/fireBaseHook";
import CcpCpBreadcrumbs from "../../Layout/inc/CcpCpBreadcrumbs";
import XcsiTable from "./XcsiTable";

const Xcsi = () => {
  const { data, loading } = useFetchXCSI();
  const { exportXCSI } = useExportXCSI();
  const { data: buildingData } = useFirestore("CcpBuildingMgt");
  const [selectedBldg, setSelectedBldg] = useState("");

  // Dropdown: sorted bldg codes from CcpBuildingMgt
  const bldgOptions = (buildingData || [])
    .filter((b) => b.bldg)
    .map((b) => String(b.bldg).trim())
    .filter(Boolean)
    .sort()
    .filter((v, i, arr) => arr.indexOf(v) === i); // dedupe

  return (
    <>
      <CcpCpBreadcrumbs pageName="XCSI" />

      <Card sx={{ width: "100%", mt: 1 }}>
        <CardContent>
          <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center" }}>
            <FormControl size="small" sx={{ minWidth: 280 }}>
              <InputLabel id="school-filter-label">
                Filter by School / Building
              </InputLabel>
              <Select
                labelId="school-filter-label"
                value={selectedBldg}
                label="Filter by School / Building"
                onChange={(e) => setSelectedBldg(e.target.value)}
              >
                <MenuItem value="">
                  <em>All Schools</em>
                </MenuItem>
                {bldgOptions.map((code) => (
                  <MenuItem key={code} value={code}>
                    {code}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button variant="contained" onClick={() => exportXCSI()}>
              Export
            </Button>
          </Box>

          <XcsiTable data={data} loading={loading} bldg={selectedBldg || null} />
        </CardContent>
      </Card>
    </>
  );
};

export default Xcsi;
